import { useFocusEffect } from "@react-navigation/native";
import { useCallback } from "react";

export function useRefreshOnFocus<T>(refetch: () => Promise<T>, isEnabled = true) {
  useFocusEffect(
    useCallback(() => {
      if (isEnabled) {
        refetch();
      }
    }, [refetch, isEnabled]),
  );
}
